import { View } from "react-native";
import React, { useState, ReactNode } from "react";
import { Icons } from "../../theme";
import { TouchableOpacity } from "react-native-gesture-handler";

export interface ChecklistOption {
  id: string;
  component: ReactNode;
  shouldBeMarked: boolean;
}

export interface ChecklistProps {
  options: ChecklistOption[];
  onSelectionChange?: (selectedIds: string[]) => void;
  disabled?: boolean;
  onValidationChange?: (isCorrect: boolean) => void;
  tries?: number;
  setTries?: (tries: number) => void;
}

export const Checklist = ({
  options,
  onSelectionChange,
  disabled,
  onValidationChange,
  tries,
  setTries,
}: ChecklistProps) => {
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const toggleItem = (id: string) => {
    if (disabled) return;

    if (setTries !== undefined) {
      setTries((tries ?? 0) + 1);
    }

    const newSelection = selectedIds.includes(id)
      ? selectedIds.filter((selectedId) => selectedId !== id)
      : [...selectedIds, id];

    setSelectedIds(newSelection);
    onSelectionChange?.(newSelection);

    // if validation change should be propagated
    if (onValidationChange) {
      const isSelectionCorrect = options.every(
        (option) => option.shouldBeMarked === newSelection.includes(option.id)
      );
      onValidationChange(isSelectionCorrect);
    }
  };

  return (
    <View>
      {options.map((option) => (
        <View
          key={option.id}
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 8,
          }}
        >
          <Checkbox
            marked={selectedIds.includes(option.id)}
            onPress={() => toggleItem(option.id)}
            disabled={disabled}
          />
          <View style={{ marginLeft: 12, flex: 1 }}>{option.component}</View>
        </View>
      ))}
    </View>
  );
};

export interface CheckboxProps {
  marked: boolean;
  onPress: () => void;
  disabled?: boolean;
}

export const Checkbox = ({ marked, onPress, disabled }: CheckboxProps) => {
  return (
    <TouchableOpacity onPress={onPress} style={{ opacity: disabled ? 0.2 : 1 }}>
      {marked ? (
        <Icons.CheckboxMarked size="huge" />
      ) : (
        <Icons.CheckboxUnmarked size="huge" />
      )}
    </TouchableOpacity>
  );
};
